import { type IFrontFooterLayoutProps } from '@framework/theme/front/FrontFooterLayout.tsx';
import { ContentLayoutWrapper } from '@framework/ui/components/layout/ContentLayoutWrapper.tsx';
import { Layout } from 'antd';
import { down } from 'styled-breakpoints';
import styled, { useTheme } from 'styled-components';
import { FrontFooterContent } from './footer/FrontFooterContent.tsx';

export const StyledFooter = styled(Layout.Footer)`
  &&& {
    background-color: ${props => props.theme.layoutFooterBgColor};
    color: ${props => props.theme.layoutFooterColor};
    font-size: 18px;
    width: 100%;
    padding: 54px 0px;
    z-index: 9;
    height: auto;
    line-height: unset;

    overflow-x: hidden;
  }
`;
export const BoxedPaddingWrapper = styled.div`
  flex-wrap: nowrap;
  max-width: 100%;
  width: 100%;
  padding: 0 24px;
  ${down('sm')} {
    padding: 0 12px;
  }
`;

/**
 * Footer dell'applicativo.
 */
export function FrontFooterLayout(props: IFrontFooterLayoutProps) {
  const { boxed = true } = props;
  const theme = useTheme();
  // Gestione interna della larghezza del'header
  const headerBoxed = theme.boxedFrontofficeHeaderFooterLayoutFlag ?? false;

  return (
    <StyledFooter id="main-footer">
      <ContentLayoutWrapper boxed={headerBoxed}>
        <BoxedPaddingWrapper>
          <FrontFooterContent />
        </BoxedPaddingWrapper>
      </ContentLayoutWrapper>
    </StyledFooter>
  );
}
